import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { formatTimeRangeToISO } from "../../../../../utils/dateTimeUtils";
import { AccountTransactionFlowFilterType, AccountTransactionFlowType } from "../graphql/types/AccountTransactionFlowType";
import {
    AccountTransactionFlowListResponse,
    GET_ACCOUNT_TRANSACTION_FLOW_LISTING
} from "../graphql/queries/getAccountTransactionFlowList";

export interface AccountTransactionFlowQueryResult {
    accountTransactionFlowData: AccountTransactionFlowType[];
    loading: boolean;
    refetch: (variables?: any) => Promise<any>;
    totalElements: number;
    buildQueryVariables: () => any;
}

export const useAccountTransactionFlowQuery = (
    filters: AccountTransactionFlowFilterType,
    currentPage: number,
    pageSize: number
): AccountTransactionFlowQueryResult => {
    const [accountTransactionFlowData, setAccountTransactionFlowData] = useState<AccountTransactionFlowType[]>([]);
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState(0);

    const buildQueryVariables = () => {
        const timeRanges = {
            virtualAccountId: filters.virtualAccountId,
            transactionTime: formatTimeRangeToISO(filters.transactionTime),
        };

        const queryFilters = {
            ...filters,
            ...timeRanges
        };

        return {
            filters: queryFilters,
            pageRequest: {
                page: currentPage,
                size: pageSize,
                sortBy: "id",
                sortDirection: "DESC"
            }
        };
    };

    // 执行查询
    const { data, loading: queryLoading, refetch } = useQuery<AccountTransactionFlowListResponse>(
        GET_ACCOUNT_TRANSACTION_FLOW_LISTING,
        { variables: buildQueryVariables() }
    );

    // 当数据变化时更新状态
    useEffect(() => {
        const responseData = data?.getAccountTransactionFlowPageable?.content;
        if (responseData) {
            setAccountTransactionFlowData(responseData);
            setLoading(false);
        }
        const totalElements = data?.getAccountTransactionFlowPageable?.totalElements;
        if (totalElements) {
            setTotal(totalElements);
        }
    }, [data]);

    return {
        accountTransactionFlowData,
        loading: loading || queryLoading,
        refetch,
        totalElements: total,
        buildQueryVariables
    };
};
